import { render, staticRenderFns } from "./CourseCommentsAdvent.vue?vue&type=template&id=f148fac0&"
import script from "./CourseCommentsAdvent.vue?vue&type=script&lang=js&"
export * from "./CourseCommentsAdvent.vue?vue&type=script&lang=js&"
import style0 from "./CourseCommentsAdvent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports